var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 85,
    r: 85
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.459 181.515c-17.997 11.687-39.448 18.485-62.459 18.485s-44.462-6.798-62.459-18.485c-19.895 7.603-38.341 18.82-54.38 33.216l116.839 43.815 116.839-43.815c-16.039-14.396-34.485-25.614-54.38-33.216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436 310h-10c-8.284 0-15 6.716-15 15v40c0 8.284 6.716 15 15 15h10c19.33 0 35-15.67 35-35 0-19.33-15.67-35-35-35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.456 234.276c-4.044 2.803-6.456 7.409-6.456 12.329v33.395h5c24.813 0 45 20.187 45 45v40c0 24.813-20.187 45-45 45h-5v31.605c0 6.253 3.879 11.85 9.733 14.045l150.267 56.35v-227.04l-139.733-52.4c-4.607-1.729-9.768-1.088-13.811 1.716z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381 365v-40c0-24.813 20.187-45 45-45h5v-33.395c0-4.92-2.412-9.526-6.456-12.329-4.044-2.804-9.206-3.445-13.811-1.716l-139.733 52.4v227.04l150.267-56.35c5.854-2.195 9.733-7.792 9.733-14.045v-31.605h-5c-24.813 0-45-20.187-45-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 365v-40c0-8.284-6.716-15-15-15h-10c-19.33 0-35 15.67-35 35 0 19.33 15.67 35 35 35h10c8.284 0 15-6.716 15-15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.0cb003ea.svg";
export { ForwardRef as ReactComponent };